// Dependencies
import React from 'react'
import _ from 'lodash'
import { AppContext } from '../contexts/AppContext'
import styled, { css } from 'styled-components'

// Types
import { Types, Containers } from '../types'

// Hooks 
import { useDebug } from '../hooks'
import AddToCartArea from "./AddToCartArea";
import BundleProductItem from './BundleProductItem'

const BundleProductWrapper = styled.div(
    ({ theme: { general, components: { productAttributes: style } } }) => css`
      display: flex;
      flex-direction: column;
      row-gap: 1em;
      margin-bottom: 2em;
    `);
  
    
const BundleProduct = ({context}: any) => {

    const {config, translations, items, onAddToCart, onVariationSelect, ...bundleProduct}: any = React.useContext(context);    

    useDebug(`BundleProduct [${bundleProduct.name}]`)
    
    return (<>
      <BundleProductWrapper>
        {Object.entries(items).map(([id, bundledItem]: any) => 
          <BundleProductItem key={id} {...{bundleProduct, product: {...bundledItem, id}, config, translations, onVariationSelect}} />)
        }
      </BundleProductWrapper>
      <AddToCartArea {...{...bundleProduct, config, translations, onAddToCart}} />
    </>)

}

export default BundleProduct;